import { useEffect, useMemo } from "react";

const DEBUG_MODE = false;

const useConditionalQuestions = (questions, formWatch, setValue) => {
  const filteredQuestions = useMemo(
    () =>
      questions
        ?.map((question) => ({
          ...question,
          dependent: question?.answers?.some((ans) => ans?.dependencies?.length > 0),
          answers: question?.answers?.filter((ans) => {
            if (ans?.dependencies?.length === 0) {
              return true;
            } else {
              const pilotQuestions = ans.dependencies
                ?.map((d) => d.pilotQuestionId)
                ?.filter(
                  (value, index, array) =>
                    array?.map((item) => item.pilotQuestionId).indexOf(value.pilotQuestionId) ===
                    index
                );
              if (DEBUG_MODE) {
                console.log(
                  "Pilot questions for question",
                  question.id,
                  "answer",
                  ans.id,
                  ":",
                  pilotQuestions
                );
              }
              return pilotQuestions?.some((q) => {
                const formValue = Number(formWatch?.[q]);
                if (formValue) {
                  const pilotAnswers = ans.dependencies
                    ?.filter((d) => d.pilotQuestionId === q)
                    ?.map((d) => d.pilotAnswerId);
                  if (DEBUG_MODE) {
                    console.log("Pilot question", q, "has answer:", pilotAnswers);
                    console.log("Current", q, "question value:", formValue);
                  }
                  return pilotAnswers?.includes(formValue);
                } else {
                  return false;
                }
              });
            }
          }),
        }))
        ?.filter((question) => (question.dependent ? question?.answers?.length > 0 : true)),
    [questions, formWatch]
  );

  useEffect(() => {
    const answeredQuestions = Object.entries(formWatch)
      ?.filter(([_questionId, value]) => !!value)
      ?.map(([questionId]) => Number(questionId));
    answeredQuestions?.forEach((answeredQuestionId) => {
      const answeredQuestion = questions?.find((q) => q.id === Number(answeredQuestionId));
      const isDependentQuestion = answeredQuestion?.answers?.some(
        (ans) => ans.dependencies.length > 0
      );
      if (isDependentQuestion) {
        if (DEBUG_MODE) {
          console.log(
            `${answeredQuestionId} is a dependent question. Check if dependencies are valid`
          );
        }
        const answer = formWatch?.[answeredQuestionId];
        const dependencies = answeredQuestion?.answers?.find(
          (ans) => ans.id === Number(answer)
        )?.dependencies;
        if (
          !dependencies?.some((dep) =>
            formWatch?.[dep.pilotQuestionId]
              ? Number(formWatch?.[dep.pilotQuestionId]) === dep.pilotAnswerId
              : false
          )
        ) {
          if (DEBUG_MODE) {
            console.log(
              `An invalid dependency is present, resetting dependent question ${answeredQuestionId} form field`
            );
          }
          setValue(
            `${answeredQuestionId}`,
            answeredQuestion?.questionType === "Dropdown" ? "" : null
          );
        }
      }
      return;
    });
  }, [formWatch, questions, setValue]);

  return { filteredQuestions };
};

export default useConditionalQuestions;
